import { css } from '@emotion/react';

import { useLocalizedStringFormatter } from '@coursera/cds-common';

import i18nMessages from '@core/Button/i18n';
import Delayed from '@core/Delayed';
import { LoadingIndicator } from '@core/loaders/LoadingIndicator';
import VisuallyHidden from '@core/VisuallyHidden';

/**
 * Loading animation for Button
 */

type Props = {
  isFocused?: boolean;
};

// display:flex + line-height:0 collapse the inline strut so translate(-50%,-50%)
// centers on the SVG dimensions alone, not SVG + inherited font line-height.
const wrapperCss = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  line-height: 0;
  --loading-indicator-stroke: currentColor;
`;

const ButtonLoader = (props: Props) => {
  const { isFocused } = props;
  const stringFormatter = useLocalizedStringFormatter(i18nMessages);
  const ariaLive = isFocused ? 'polite' : 'off';

  return (
    <span aria-live={ariaLive}>
      <Delayed>
        <VisuallyHidden>{stringFormatter.format('loading')}</VisuallyHidden>
      </Delayed>
      <span css={wrapperCss} data-testid="cds-button-loading-indicator">
        <LoadingIndicator decorative />
      </span>
    </span>
  );
};

export default ButtonLoader;
